import { defineMessages } from "react-intl";
const messages = defineMessages({
    leasingOfficeOption: {
        id: "app.scanRequests.accessDetailSelector.leasingOffice.option",
        defaultMessage: "Leasing office will provide access",
    },
    otherOption: {
        id: "app.scanRequests.accessDetailSelector.other.option",
        defaultMessage: "Other",
    },
});
export default messages;
